import React from "react";
//import "react-responsive-carousel/lib/styles/carousel.css";
import { Carousel } from 'react-responsive-carousel';

class SalesGallery extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                <Carousel
                    showThumbs={false}
                    showStatus={false}
                    autoPlay interval={7000} infiniteLoop
                >
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07626.png" className="focused" />
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07632.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07637.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07641.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07650.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07652.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07661.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07665.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07671.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07704.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07707.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07708.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07722.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07751.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07756.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07758.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07760.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/DSC07764.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/SAIGA 1.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/SAIGA 2.png"/>
                    </div>
                    <div className="sales-gallery slide">
                        <img src="/images/Gallery/custom/SAIGA 3.png"/>
                    </div>
                </Carousel>
            </div>
        );
    }
}

export default SalesGallery;